export const Sunburst = () => (
  <div className="fixed inset-0 pointer-events-none z-0" aria-hidden="true">
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_-10%,rgba(140,123,107,0.16),transparent_55%)]" />
    <div
      className="absolute inset-0 opacity-[0.05]"
      style={{
        background:
          "repeating-conic-gradient(from 0deg at 50% -15%, rgba(140,123,107,0.9) 0deg 4deg, transparent 4deg 12deg)",
      }}
    />
  </div>
);
